<template>
  <div v-if="meta && total > 0" class="row">
    <div class="col">
      <div class="d-flex justify-content-center">
        <APagination
          v-model:current="page"
          :page-size="meta.per_page"
          :show-size-changer="false"
          :show-total="showTotal"
          :total="total"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType } from 'vue'
import { PaginationMeta, SimplePaginationMeta } from '@/api/PaginatedResponse'
import { asyncComponentWrapper } from '@/composables/useReloadModal'

const APagination = asyncComponentWrapper(() => import('ant-design-vue/es/pagination'))

const props = defineProps({
  meta: {
    type: Object as PropType<PaginationMeta | SimplePaginationMeta | undefined | null>,
    default: null,
  },
})

const page = defineModel({ type: Number as PropType<number | undefined> })

const total = computed(() => {
  if (!props.meta) {
    return 0
  }

  if ('total' in props.meta) {
    return props.meta.total
  }

  if (props.meta.to === null || props.meta.from === props.meta.to) {
    // if user is on first page, and it's empty, return 0 to not render pagination
    // if user is on a page which does not exist, calculate total in order to render component with possibility to go back
    return props.meta.current_page === 1 ? 0 : props.meta.current_page * props.meta.per_page
  }

  if ('has_more_pages' in props.meta) {
    // if we know there are more pages, add +1 to the total for the component to render next page navigation
    return props.meta.has_more_pages ? props.meta.to + 1 : props.meta.to
  }

  // if we don't know if there are more pages, add +1 to the total for the component to render next page navigation
  return props.meta.to + 1
})

const showTotal = (total: number, range: number[]) => {
  if (!props.meta) return ''

  const [from, to] = range

  if ('total' in props.meta) {
    return `${from}-${to} of ${total} items`
  }

  return `${from}-${to}`
}
</script>
